import { Card } from "@jti/core-components/components/Card";
import { DeliveryOptionType } from "@jti/store/slices/LEGACY__checkoutSlice";
import type { BillingAddressType } from "@jti/store/types";
import { useTranslations } from "@jti/ui";

import { BillingAddressAlternativeDelivery } from "./BillingAddressAlternativeDelivery";
import { BillingAddressAtHomeDelivery } from "./BillingAddressAtHomeDelivery";
import { BillingErrorMessageBox } from "./BillingErrorMessageBox";

type BillingAddressProps = {
  deliveryOptionType?: DeliveryOptionType;
  billingAddressType: BillingAddressType;
  errorMessage?: string;
};

export const BillingAddress = ({
  deliveryOptionType = DeliveryOptionType.AtHome,
  billingAddressType,
  errorMessage,
}: BillingAddressProps) => {
  const { __ } = useTranslations();

  return (
    <Card title={__("cart.billing.title")} variant="level-1" data-testid="billingAddressCard">
      {errorMessage && <BillingErrorMessageBox>{errorMessage}</BillingErrorMessageBox>}

      {deliveryOptionType === DeliveryOptionType.AtHome ? (
        <BillingAddressAtHomeDelivery value={billingAddressType} />
      ) : (
        <BillingAddressAlternativeDelivery />
      )}
    </Card>
  );
};
